// pages/protocol-handler.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ProtocolHandler() {
  const location = useLocation();
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const url = params.get('url');
    
    if (url) {
      const cleanUrl = decodeURIComponent(url).replace('antsrdp://', '');
      window.location.href = `antsrdp://${cleanUrl}`;
    }
  }, [location]);

  return <div>Connecting to remote desktop...</div>;
}